import { requiresDocumentReview } from './documentReviewPolicy';
const text = value => String(value || "").trim();

// Public uploads belong to a requested card until staff assign a requirement.
// Use the review screen's existing scan classification to narrow grouped cards.
export function pendingReviewFilesFromSubmissions(submissions, matchesDetectedKind) {
  return (submissions || []).flatMap(sub => (sub.files || []).flatMap(file => {
    if (!file.objectPath || !requiresDocumentReview(file) || ["approved", "rejected", "staff_upload_pending"].includes(file.review?.status)) return [];
    const explicitKey = text(file.review?.requirementKey || file.requirementKey);
    const snapshot = sub.cardSnapshots?.[file.cardId] || {};
    const options = Array.isArray(snapshot.options) ? snapshot.options : [];
    const detectedOptions = options.filter(option => matchesDetectedKind(file, option));
    const applicableOptions = detectedOptions.length ? detectedOptions : options;
    const keys = explicitKey ? [explicitKey] : applicableOptions.map(option => text(option.key)).filter(Boolean);
    return [{
      ...file,
      __submissionId: sub.id,
      __requirementKeys: keys,
      __assignmentPending: !explicitKey && !detectedOptions.length && keys.length > 1,
    }];
  })).sort((a, b) => Number(a.__assignmentPending) - Number(b.__assignmentPending));
}

export function pendingFileMatchesRequirement(file, context) {
  const meta = context.cardSnapshot?.meta || {};
  const docKey = text(context.requirementKey).split(":").pop();
  const keys = new Set([
    context.requirementKey,
    ...[meta.partyId, meta.displayPartyId, ...(meta.sourcePartyIds || [])]
      .filter(Boolean).map(id => `party:${id}:${docKey}`),
  ]);
  return file.__requirementKeys.some(key => keys.has(key));
}
